module.exports = __webpack_public_path__ + "img/success.bee1fef1.svg";